import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { PageScreen, type PageSearch } from "../../screens/pages/index.ts";

/**
 * `/pages/$pageId`: a page wired to core. The filters changed on screen (`?f=`), the view (`?view=report|present`,
 * `?slide=`) and the comments pane (`?pane=comments`) live in the address, so a link shows the same page. Every
 * number shows for the filters on screen (last night's recording or a recent run first, then each block that needs a
 * run, no AI; Refresh runs them all). Asking from the page opens a thread about it.
 */
export const Route = createFileRoute("/_app/pages/$pageId")({
  validateSearch: (s: Record<string, unknown>): PageSearch => ({
    ...(typeof s.f === "string" ? { f: s.f } : {}),
    ...(s.view === "report" || s.view === "present" ? { view: s.view } : {}),
    ...(typeof s.slide === "number" ? { slide: s.slide } : {}),
    ...(s.pane === "comments" ? { pane: "comments" as const } : {}),
  }),
  loader: ({ context, params }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("pages.get", { pageId: params.pageId })),
  component: PageScreen,
});
